import { styled } from '@mui/material/styles';

const LoginWrapper = styled('div')`
  height: 100vh;
  width: 100vw;
  background-color: #f9f9fa;
`;

export default LoginWrapper;
